module.exports = __webpack_public_path__ + "static/media/CHRISTMAS-TRIO.aa151d07.jpeg";